<template>
    <div
      class="fill-height"
      :style="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? `padding-bottom: 600px; padding-top: 130px;` : `padding-bottom: 900px; padding-top: 64px;`">
      <v-layout wrap>
        <v-flex>
          <section>
            <v-container>
              <v-row>
                <v-col cols="12" md="9">
                  <div class="mb-4 d-flex align-center text-second" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'body-1' : 'body-2'">
                    <v-btn text to="/IPKD" class="text-capitalize px-1" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'body-1' : 'body-2'" color="blue">
                      IPKD
                    </v-btn>
                    <div class="mr-3 ml-1">
                      .|.
                    </div>
                    <div>
                      Detail IPKD
                    </div>
                  </div>
                  <div v-if="process.load">
                    <v-card
                      flat
                      height="100%"
                      v-if="process.load"
                      :min-height="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? '100vh' : '100vh'"
                      :max-height="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? '100vh' : '100vh'"
                      color="#00000040">
                      <v-skeleton-loader
                        v-if="process.load"
                        :loading="process.load"
                        transition="scale-transition"
                        :tile="false"
                        class="ma-auto load_card_x_large"
                        type="image"
                        style="width: 100% !important; height: 100% !important; min-height: 100% !important;">
                      </v-skeleton-loader>
                    </v-card>
                  </div>
                  <v-card flat class="pa-0 detail-doc-card overflow-hidden" v-if="!process.load && Object.keys(detail).length > 0">
                    <div class="doc-header d-flex align-center">
                      <v-icon color="white" class="mr-2">mdi-file-document-outline</v-icon>
                      <span class="doc-header-title">Detail IPKD</span>
                    </div>

                    <div class="document-stats-strip">
                      <div class="document-stat-box">
                        <svg class="stat-icon" viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#1e40af" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        <div>
                          <strong>{{ detail.view_count }}</strong>
                          <span>Dilihat</span>
                        </div>
                      </div>
                      <div class="document-stat-box">
                        <svg class="stat-icon" viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#1e40af" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>
                        </svg>
                        <div>
                          <strong>{{ detail.file_url_array ? detail.file_url_array.length : 0 }}</strong>
                          <span>Lampiran</span>
                        </div>
                      </div>
                    </div>

                    <table class="detail-table">
                      <tbody>
                        <tr>
                          <th>Judul</th>
                          <td>{{ detail.title }}</td>
                        </tr>
                        <tr>
                          <th>Tanggal Publish</th>
                          <td>{{ detail.publish_datetime | date }}</td>
                        </tr>
                        <tr>
                          <th>Penulis</th>
                          <td>Admin</td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="pa-5">
                      <div v-if="detail.image_type === 'single' && detail.image_url.length > 0" class="mb-4">
                        <img style="border-radius: 6px; width: 100%; object-fit: contain;" :src="detail.image_url === '' ? require('@/assets/image/no-photo.png') : detail.image_url" @contextmenu.stop>
                      </div>
                      <div v-if="detail.image_type === 'multiple'" class="mb-4">
                        <v-carousel height="500" width="100%">
                          <v-carousel-item
                            v-for="(item,i) in detail.image_url_json"
                            :key="i"
                            style="border-radius: 6px;"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                          >
                            <img
                              :src="item.src"
                              style="width: 100%; height: 100%; object-fit: contain; border-radius: 6px;"
                              :alt="item.alt || 'Gambar IPKD'"
                              loading="lazy">
                          </v-carousel-item>
                        </v-carousel>
                      </div>

                      <div class="font-weight-regular" :class="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' ? 'body-1' : 'body-2'" style="font-size: 18px;" v-html="detail.content">
                      </div>

                      <!-- Lampiran Section -->
                      <div v-if="detail.file_url_array && detail.file_url_array.length > 0" class="mt-4">
                        <h3 class="text-h6 mb-3">
                          <v-icon class="mr-2" color="primary">mdi-attachment</v-icon>
                          Lampiran
                        </h3>
                        <v-list dense>
                          <template v-for="(file, index) in detail.file_url_array">
                            <v-list-item
                              :key="index"
                              class="px-0"
                            >
                              <v-list-item-icon class="mr-3">
                                <v-icon
                                  :color="getFileIconColor(file.extension)"
                                  size="24"
                                >
                                  {{ getFileIcon(file.extension) }}
                                </v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="text-body-2">
                                  {{ file.name }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-caption">
                                  {{ file.extension.toUpperCase() }} •
                                  <a
                                    :href="file.url"
                                    target="_blank"
                                    class="text-decoration-none"
                                    style="color: inherit;"
                                  >
                                    Download
                                  </a>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn
                                  icon
                                  small
                                  :href="file.url"
                                  target="_blank"
                                  color="primary"
                                >
                                  <v-icon>mdi-download</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                            <div
                              v-if="file.extension.toLowerCase() === 'pdf'"
                              :key="`preview-${index}`"
                              class="mb-3"
                            >
                              <iframe
                                :src="`${file.url}#view=FitH&toolbar=1&navpanes=0`"
                                class="preview-frame"
                              ></iframe>
                            </div>
                          </template>
                        </v-list>
                      </div>
                      <v-divider class="my-5"></v-divider>
                      <v-avatar
                        v-for="(item, index) in sosmed"
                        :key="index"
                        tile
                        width="50"
                        height="50">
                        <ShareNetwork
                          :network="item.network"
                          :url="`${host}${$route.fullPath}`"
                          :title="detail.title"
                          :image="detail.image_url"
                          :description="detail.meta_json.image"
                          hashtags="Klaten,diskominfo">
                          <img
                            style="width: 40px; height: 40px; object-fit: contain;"
                            alt="Klaten"
                            :src="item.icon">
                        </ShareNetwork>
                      </v-avatar>
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="12" md="3">
                  <!-- <Sidebar /> -->
                  <section>
                    <Sidebar />
                  </section>
                </v-col>
              </v-row>
            </v-container>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { createSEOMeta } from '@/utils/seo'
    export default {
      middleware: false,
      data () {
        return {
          dateNow: new Date(),
          detail: {},
          sosmed: [
            { network: 'facebook', icon: require('@/assets/sosmed/ic_share_fb.svg') },
            { network: 'instagram', icon: require('@/assets/sosmed/ic_share_ig.svg') },
            { network: 'twitter', icon: require('@/assets/sosmed/ic_share_tw.svg') },
            { network: 'telegram', icon: require('@/assets/sosmed/ic_share_tel.svg') },
            { network: 'whatsapp', icon: require('@/assets/sosmed/ic_share_wa.svg') }
          ],
          category: [],
          process: {
            load: false,
            category: false
          },
          total_category: 0,
          message: {
            success: '',
            error: ''
          },
          // SEO
          content: {
            url: '/IPKD/:slug',
            title: this.$route.params.slug.split('-').join(' ').split('=').join('-').split('>').join('/'),
            description: 'Detail IPKD Kabupaten Klaten',
            image: require('@/assets/logo/favicon.png')
          }
        }
      },
      head () {
        return {
          title: this.content.title,
          meta: createSEOMeta(this.content)
        }
      },
      components: {
        Sidebar: () => import(/* webpackPrefetch: true */ '@/components/sidebar/index')
      },
      watch: {
  
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.member.auth.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.header.config.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.header.config.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
        host () {
          return process.env.HOST_NAME
        }
      },
      mounted () {
        this.fetch()
        this.fetchCategory()
      },
      methods: {
        getFileIcon (extension) {
          const iconMap = {
            'pdf': 'mdi-file-pdf-box',
            'doc': 'mdi-file-word-box',
            'docx': 'mdi-file-word-box',
            'xls': 'mdi-file-excel-box',
            'xlsx': 'mdi-file-excel-box',
            'ppt': 'mdi-file-powerpoint-box',
            'pptx': 'mdi-file-powerpoint-box',
            'txt': 'mdi-file-document-outline',
            'zip': 'mdi-file-zip-box',
            'rar': 'mdi-file-zip-box',
            'jpg': 'mdi-file-image',
            'jpeg': 'mdi-file-image',
            'png': 'mdi-file-image',
            'gif': 'mdi-file-image',
            'mp4': 'mdi-file-video',
            'avi': 'mdi-file-video',
            'mp3': 'mdi-file-music',
            'wav': 'mdi-file-music'
          }
          return iconMap[extension.toLowerCase()] || 'mdi-file-document-outline'
        },
        getFileIconColor (extension) {
          const colorMap = {
            'pdf': 'red',
            'doc': 'blue',
            'docx': 'blue',
            'xls': 'green',
            'xlsx': 'green',
            'ppt': 'orange',
            'pptx': 'orange',
            'txt': 'grey',
            'zip': 'purple',
            'rar': 'purple',
            'jpg': 'pink',
            'jpeg': 'pink',
            'png': 'pink',
            'gif': 'pink',
            'mp4': 'indigo',
            'avi': 'indigo',
            'mp3': 'teal',
            'wav': 'teal'
          }
          return colorMap[extension.toLowerCase()] || 'grey'
        },
        async fetchCategory (id, type) {
          this.process.category = type === undefined ? true : false
  
          let params = {
            limit: 1000000,
            par_id: '0',
            category_id: '19'
          }
  
          await this.$axios.$get(`${process.env.API}sites/article/category`, { params })
          .then(response => {
            let res = response
  
            if (res.status === 200) {
              this.category = [
                {
                  category_title: "Semua Kategori",
                  category_icon_url: require('@/assets/icon/app.png'),
                  id: '',
                  category_name: "semua-kategori",
                  count: 0
                }
              ]
              let category = []
              category = res.results.data.map(item => {
                  const container = {};
  
                  container.category_title = item.title;
                  container.category_icon_url = item.icon_url;
                  container.id = item.id;
                  container.category_name = item.slug;
                  container.count = item.count
  
                  // this.category = container;
                  return container
                })
  
  
              for (let i in category) {
                this.category.push(
                  {
                    category_title: category[i].category_title,
                    category_icon_url: category[i].category_icon_url,
                    id: category[i].id,
                    category_name: category[i].category_name,
                    count: category[i].count
                  }
                )
  
              }
  
              for (let i in this.category) {
                this.total_category += parseInt(this.category[i].count)
  
              }
  
              this.process.category = false
              this.category[0].count = this.total_category
            }
          })
        },
        async fetch () {
          this.process.load = true
  
          let params = {
            slug: this.$route.params.slug
          }
  
          await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
          .then(response => {
            let res = response
  
            // this.process.load = false
  
            if (res.status === 200) {
              this.detail = res.results.data[0]
              this.fetchDetail()
              if (res.results.data.length < 1 || res.results.data.length > 1) {
                this.fetchDetailbyID()
              }
              // if (this.detail.doc_type_par_id !== '4') {
              //   this.detail.penetapan_date = new Date(this.detail.penetapan_date).getFullYear()
              // }
            } else {
              this.process.load = false
            }
          })
          .catch(() => {
            this.process.load = false
          })
        },
        async fetchDetailbyID () {
          this.process.load = true
  
          let params = {
            id: this.$route.query.q
          }
  
          await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
          .then(response => {
            let res = response
  
            // this.process.load = false
  
            if (res.status === 200) {
              this.detail = res.results.data[0]
              this.fetchDetail()
              if (res.results.data.length < 1 || res.results.data.length > 1) {
                this.process.load = false
              }
              // if (this.detail.doc_type_par_id !== '4') {
              //   this.detail.penetapan_date = new Date(this.detail.penetapan_date).getFullYear()
              // }
            } else {
              this.process.load = false
            }
          })
          .catch(() => {
            this.process.load = false
          })
        },
        async fetchDetail () {
          this.process.load = true
  
          let params = {
            id: this.detail.id
          }
  
          await this.$axios.$get(`${process.env.API}sites/article/data`, { params })
          .then(response => {
            let res = response
  
            this.process.load = false
  
            if (res.status === 200) {
              this.detail = res.results.data[0]
              this.detail.meta_json = JSON.parse(res.results.data[0].meta_json)
              if (this.detail.image_url_json,length > 0) {
                this.detail.image_url_json = JSON.parse(this.detail.image_url_json)
                this.detail.image_url_json = this.detail.image_url_json.map(item => {
                  const container = {};
  
                  container.src = item
  
                  // this.category = container;
                  return container
                })
              }
              // this.detail = res.results.data
              // if (this.detail.doc_type_par_id !== '4') {
              //   this.detail.penetapan_date = new Date(this.detail.penetapan_date).getFullYear()
              // }
            }
          })
          .catch(() => {
            this.process.load = false
          })
        },
        downloadFile(fileURL, fileName) {
          const link = document.createElement('a');
        link.href = fileURL;
        link.target = '_blank';
        link.download = fileName;
  
        // Simulate a click on the element <a>
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
          // fetch(url, { method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer' })
          //   .then(res => res.blob())
          //   .then(res => {
          //     // console.log(this.getFile(fileName).split('/')[5])
          //     const aElement = document.createElement('a');
          //     aElement.setAttribute('download', fileName);
          //     const href = URL.createObjectURL(res);
          //     aElement.href = href;
          //     aElement.setAttribute('target', '_blank');
          //     aElement.click();
          //     URL.revokeObjectURL(href);
          //   });
        },
        // async fetchDetail () {
        //   this.process.load = true
  
        //   let params = {
        //     id: this.$route.params.slug
        //   }
  
        //   await this.$axios.$get(`${process.env.API}sites/article/detail`, { params })
        //   .then(response => {
        //     let res = response
  
        //     this.process.load = false
  
        //     if (res.status === 200) {
        //       this.detail = res.results.data
        //       this.detail.meta_json = JSON.parse(res.results.data.meta_json)
        //     }
        //   })
        // }
      }
    }
  </script>

  <style scoped>
    .detail-doc-card {
      border-radius: 8px;
      border: 1px solid rgba(15, 23, 42, 0.12);
      box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
    }

    .doc-header {
      background: #1e40af;
      color: #fff;
      padding: 0.85rem 1.5rem;
    }

    .doc-header-title {
      font-size: 1.25rem;
      font-weight: 600;
    }

    .document-stats-strip {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 0;
      border-bottom: 1px solid #e5e7eb;
      background: #f8fafc;
    }

    .document-stat-box {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 1rem 1.25rem;
      border-right: 1px solid #e5e7eb;
    }

    .document-stat-box:last-child {
      border-right: 0;
    }

    .stat-icon {
      display: block;
      flex-shrink: 0;
    }

    .document-stat-box strong,
    .document-stat-box span {
      display: block;
    }

    .document-stat-box strong {
      color: #111827;
      font-size: 1.25rem;
      line-height: 1.1;
    }

    .document-stat-box span {
      color: #64748b;
      font-size: 0.9rem;
    }

    .detail-table {
      width: 100%;
      border-collapse: collapse;
      margin: 0;
    }

    .detail-table th,
    .detail-table td {
      border: 1px solid #e5e7eb;
      padding: 0.75rem 1rem;
      text-align: left;
      vertical-align: top;
      font-size: 0.95rem;
    }

    .detail-table th {
      width: 200px;
      background: #f8fafc;
      color: #374151;
      font-weight: 600;
    }

    .preview-frame {
      display: block;
      width: 100%;
      min-height: clamp(420px, 70vh, 800px);
      border: 1px solid #e5e7eb;
      border-radius: 6px;
      background: #111827;
    }

    @media (max-width: 640px) {
      .document-stats-strip {
        grid-template-columns: 1fr;
      }

      .document-stat-box {
        border-right: 0;
        border-bottom: 1px solid #e5e7eb;
      }

      .document-stat-box:last-child {
        border-bottom: 0;
      }

      .detail-table th {
        width: 130px;
      }
    }
  </style>
  